import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import imageImage from "@/assets/agent-user-detail/image@3x.webp";

export const ImageImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[imageImage]}
      {...props}
    />
  );
};

ImageImage.displayName = 'ImageImage';
